import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type UpdateGatewayApiResponse } from '../services/updateGatewayService'

export interface UpdateGatewayState {
  isLoading: boolean
  error: string | undefined
  data: UpdateGatewayApiResponse | undefined
  httpStatus: number | undefined
}

export const initialState: UpdateGatewayState = {
  isLoading: false,
  error: undefined,
  data: undefined,
  httpStatus: 0
}

const updateGatewaySlice = createSlice({
  name: 'UpdateGatewaySlice',
  initialState,
  reducers: {
    updateGatewayLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: undefined,
        httpStatus: 0
      }
    },
    updateGatewayUpdateAction: (state, action: PayloadAction<{ data: UpdateGatewayApiResponse, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    updateGatewayErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: undefined,
        httpStatus: action.payload.httpStatus
      }
    },
    reset: () => initialState
  }
})

export const {
  updateGatewayLoadingAction,
  updateGatewayUpdateAction,
  updateGatewayErrorAction,
  reset
} = updateGatewaySlice.actions

export default updateGatewaySlice.reducer
